import { useMemo } from 'react';
import { useUnit } from 'effector-react';
import { $profileFeatureStore } from '@lib/store';
import { PermissionUtils } from '@shared/utils';
import type { AccountFlow } from '@shared/api';

export const useAccountFlow = (accountId?: number): AccountFlow | null => {
  const { data } = useUnit($profileFeatureStore.store);

  return useMemo(() => PermissionUtils.findAccountFlow(data?.accountFlows, accountId), [data?.accountFlows, accountId]);
};
